var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",class:{ small: _vm.size === 'small' },attrs:{"data-testid":"loader"}})}
var staticRenderFns = []

export { render, staticRenderFns }